import React, {Component} from 'react';
import {InputItem, Radio ,Toast} from 'antd-mobile';
import {getIdentityCode,bindingIdentity,getAccounts} from '../../service/memberService';
import "./style.less";
import connect from "react-redux/es/connect/connect";
const phoneReg = /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class IdentityBinding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeList: [
                {value: 4, label: '我是司机'},
                {value: 6, label: '我是调度人员'},
            ],
            typeVal:"",
            jobNum:'',
            jobNumPassword:'',
            phone:'',
            code:'',
            getCodeDisabled: false,
            getCodeText: '获取验证码',
            accountsData:{
                dispatcher:[],
                driver:[],
            }
        };
    }
    componentDidMount() {
        // console.log(this.props)
        this.getBinding()
    }
    getBinding(){
        let params = {
            source:1,
            token:this.props.userInfo.token,
        };
        getAccounts(params).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({
                    accountsData:res.data.data,
                })
            }else{
                Toast.info(res.data.msg)
            }
        })
    }
    inputChange = (v, key) => {
        this.setState({[key]: v,});
    };
    // 获取验证码
    getCode = () => {
        if (this.state.typeVal == "") {
            Toast.fail('请选择绑定的身份', 2);
            return
        }
        if (!phoneReg.test(this.state.phone.replace(/\s/ig, ''))) {
            Toast.fail('请输入正确的手机号', 2);
            return
        }
        this.setState({getCodeDisabled: true,});
        let params = {
            phone: this.state.phone.replace(/\s/ig, ''),
            source:this.state.typeVal,
        };
        getIdentityCode(params).then((res) => {
            if (res.data.code === '0000') {
                this.setDownTime(60);
            } else {
                this.setState({getCodeDisabled: false,});
                Toast.info(res.data.msg,3)
            }
        })
    };

    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeText: time + 's后重新获取'});
            } else {
                this.setState({getCodeText: '获取验证码'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };

    bindingBtn = () => {
        if (this.state.typeVal == "") {
            Toast.fail('请选择绑定的身份', 2);
            return
        }
        if (this.state.jobNum == "") {
            Toast.fail('请输入工号', 2);
            return
        }
        if (this.state.jobNumPassword == "") {
            Toast.fail('请输入登录密码', 2);
            return
        }
        if (!phoneReg.test(this.state.phone.replace(/\s/ig, ''))) {
            Toast.fail('请输入正确的手机号', 2);
            return
        }
        if (this.state.code.length !== 4 && this.state.code.length !== 6) {
            Toast.fail('请输入正确的验证码', 2);
            return
        }
            Toast.loading("",0);
            let params = {
                source:1,
                token:this.props.userInfo.token,
                data:{
                    source:this.state.typeVal,
                    account:this.state.jobNum,
                    passwd:this.state.jobNumPassword,
                    phone: this.state.phone.replace(/\s/ig, ''),
                    smsCode: this.state.code,
                }
            };
            console.log(params.data);
            bindingIdentity(params).then((res)=>{
                if(res.data.code === '0000'){
                    Toast.info("绑定成功！",2,()=>window.location.reload())
                }else{
                    Toast.info(res.data.msg,3)
                }
            });

    };
    render(){
        const {typeList,typeVal}=this.state;
        return(
            <div className="identityBinding">
                {
                    this.state.accountsData.driver == "" ? null : (
                        <div className="accounts">
                            当前已绑定司机账号：
                            {
                                this.state.accountsData.driver.map((res)=>{
                                    return res + " "
                                })
                            }
                        </div>
                    )
                }
                {
                    this.state.accountsData.dispatcher == "" ? null : (
                        <div className="accounts">
                            当前已绑定调度账号：
                            {
                                this.state.accountsData.dispatcher.map((res)=>{
                                    return res + " "
                                })
                            }
                        </div>
                    )
                }
                <div className="top">
                    {typeList.map((res, i) => (
                        <Radio className="my-radio" key={i} checked={typeVal === res.value}
                               onChange={() => this.setState({typeVal: res.value})}>
                            {res.label}
                        </Radio>
                    ))}
                </div>
                <div className="middle">
                    <InputItem
                        clear
                        type="number"
                        placeholder="请输入工号"
                        value={this.state.jobNum}
                        onChange={v => this.inputChange(v, 'jobNum')}
                    >
                        工号
                    </InputItem>
                    <InputItem
                        clear
                        type="password"
                        placeholder="请输入登录密码"
                        value={this.state.jobNumPassword}
                        onChange={v => this.inputChange(v, 'jobNumPassword')}
                    >
                        登录密码
                    </InputItem>
                    <InputItem
                        clear
                        type="phone"
                        placeholder="请输入预留手机号"
                        value={this.state.phone}
                        onChange={v => this.inputChange(v, 'phone')}
                    >
                        手机号
                    </InputItem>
                    <InputItem
                        clear
                        type="number"
                        maxLength={6}
                        placeholder="请输入验证码"
                        value={this.state.code}
                        onChange={v => this.inputChange(v, 'code')}
                        extra={
                            <button
                                style={this.state.getCodeDisabled ? {color:"#fff",border:"none"}:null}
                                disabled={this.state.getCodeDisabled}
                                onClick={this.getCode}
                            >{this.state.getCodeText}</button>
                        }
                    >
                        验证码
                    </InputItem>
                    <div className="bottom" onClick={this.bindingBtn}>立即绑定</div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/IdentityBinding/index.js